import * as React from "react";
import { clientAppSettings } from "../../Models/ClientAppSettings";
import * as Rest from "../../Generated/RestClient";
import { ControllerBase } from "../Controllers/ControllerBase";
import { getAzureIbizaBotUrl } from "../../Utils/Links";
import { FooterControl } from "../../../../Intercom.ReactUI/Views/index";
import {BotImageControl} from "../../../../Intercom.ReactUI/Views/BotImageControl";

export interface BotsPageProps extends React.Props<BotsPage> {
    channelFilter?: string;
    onNextPage: () => void;
    controller: ControllerBase;

    // Navigate to the create/provision bot page.
    createBot(): void;

    // Navigate to bot page or Azure depending on the migration status of the bot
    navigateToBot: (bot: Rest.BotDocument) => void;


    // Delete a bot in the list
    deleteBot: (botId: string) => void;
}

export interface BotsPageState {
    bots: Rest.BotDocument[];
    loadingMoreBots?: boolean;
    hasMoreBots?: boolean;
    searchString?: string;
    continuationToken?: string;
}

// start loading the next page of content when the bottom of bot listing
// is less than PAGING_THRESHOLD away from window bottom
export const PAGING_THRESHOLD = 100;

export class BotsPage extends React.Component<BotsPageProps, BotsPageState> {

    private unsubscribeScroll: any;

    constructor(props) {
        super(props);
        this.state = {
            bots: [],
            continuationToken: null
        };
    }

    private onScroll(pageContent: Element) {
        const windowBottom = pageContent.scrollTop + pageContent.clientHeight;
        const $page = $('.my-bots');

        if ($page.length === 1) {
            const pageBottom = $page.scrollTop() + $page.height();

            if (pageBottom - windowBottom < PAGING_THRESHOLD &&
                !this.state.loadingMoreBots && this.state.hasMoreBots) {
                this.props.onNextPage();
            }
        }
    }

    public componentDidMount() {
        this.unsubscribeScroll = this.props.controller.app.onscroll((element) => this.onScroll(element));
    }

    public componentWillUnmount() {
        if (this.unsubscribeScroll) {
            this.unsubscribeScroll();
        }
    }

    public render(): JSX.Element {
        const bots = this.renderBots();

        return (
            <div className="my-bots-page">
                {!this.state.searchString ? this.renderNoBotsPrompt() : null}
                <div className="my-bots page-grid-left">
                    {this.renderChannelFilter()}
                    {bots}
                </div>
                <FooterControl scrollingClass="my-bots-page" />
            </div>
        );
    }

    private renderNoBotsPrompt(): JSX.Element {
        return (
            <div className="no-bots-prompt">
                <h1>{"You haven't registered any bots yet"}</h1>
                <p>{"Don't have a bot?"} <a href={clientAppSettings.documentationUrl}>Learn how to build and deploy one</a></p>
                <button className='m-button-primary-outline-md create-bot' onClick={this.props.createBot}>Create a bot</button>
            </div>
        );
    }

    private renderChannelFilter(): JSX.Element {
        if (!this.props.channelFilter) {
            return null;
        }
        let filterChannelId = this.props.channelFilter;
        if (filterChannelId.indexOf('_all_') === 0) {
            filterChannelId = filterChannelId.substr(5);
        }

        const channels = clientAppSettings.channels.filter(x => x.Id === filterChannelId);
        const selectedChannel = channels.length ? channels[0] : null;

        if (!selectedChannel) {
            return null;
        }

        const allChannelId = `_all_${this.props.channelFilter}`;
        const allChannel = {
            Name: 'All channels',
            Id: allChannelId
        }
        return (
            <section>
                <label htmlFor='channel_filter'>Channel filter</label>
                <p className="channel_filter_box">
                    <select id='channel_filter' onChange={e => {
                        const newChannelFilter = e.currentTarget.value;
                        this.props.controller.app.navigate('/bots', { c: newChannelFilter });
                    }}>
                        <option value={allChannelId} selected={this.props.channelFilter === allChannelId}>{allChannel.Name}</option>
                        <option value={filterChannelId} selected={this.props.channelFilter === filterChannelId}>{selectedChannel.Name}</option>
                    </select>
                </p>
            </section>
        );
    }

    private renderBots(): JSX.Element {
        if (this.state.bots && this.state.bots.length > 0) {
            const rows = [];

            for (let i = 0; i < this.state.bots.length; i++) {
                const bot = this.state.bots[i];
                const name = bot.Name ? bot.Name : '(unnamed)';
                let linkHref;
                if (bot.Kind) {
                    linkHref = getAzureIbizaBotUrl(bot.SubscriptionId, bot.ResourceGroupName, bot.Id);
                } else {
                    linkHref = `${clientAppSettings.homeUrl === '/' ? '/' : ''}bots?id=${bot.Id}`;
                }
                const row = (
                    <div className="agent bot-card-hero" key={i} data-agent-id={bot.Id} onClick={() => this.props.navigateToBot(bot)}>
                        <BotImageControl bot={bot} className="image-cell"
                            transparentBackground={true}
                            defaultIconUrl={clientAppSettings.defaultIconUrl}/>
                        <div className="bot-content">
                            <a className="link-underline" href={linkHref} onClick={(ev) => ev.preventDefault()}>{bot.Name}</a>
                        </div>
                    </div>
                );
                rows.push(row);
            }
            return (
                <div data-test-id="my-bots">
                    <div className="flex-layout-grid stretched-row">
                        <h2>My bots</h2>
                        <button className='m-button-primary-outline-md create-bot' onClick={this.props.createBot}>Create a bot</button>
                    </div>
                    {rows}
                </div>
            );
        }
        else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/BotsPage.tsx